<template>
	<div class="c-image-block">
		<div class="c-image-block__inner">
			<div class="c-image-block__wrapper">
				<img :src="block.content.url" />
				<p>
					{{ block.content.url }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},

	props: {
		block: {
			type: Object,
		},
	},

	computed: {},
};
</script>

<style lang="scss">
.c-image-block {
	&__inner {
		width: 100%;
	}

	&__wrapper {
		position: relative;
		display: inline-block;

		> img {
			display: block;
			margin: 0 auto;
			max-width: 100%;
			height: auto;
			border-radius: var(--border-radius-sm);
			user-select: none;
			background-color: var(--g1);
			box-shadow: 0 0 0 3px var(--g2);
		}

		> p {
			position: absolute;
			left: var(--margin-lg);
			bottom: var(--margin-lg);
			padding: var(--margin);
			margin-right: var(--margin-lg);
			margin-bottom: 0;
			margin-top: var(--margin-lg);
			font-size: var(--font-size-xs);
			opacity: 0;
			word-break: break-all;
			border-radius: var(--border-radius-sm);
			background-color: rgba(0, 0, 0, 0.5);
			transition: opacity var(--transition-time-sm) linear;
		}
	}

	&:hover {
		.c-image-block__wrapper {
			> p {
				opacity: 1;
			}
		}
	}
}
</style>